import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/fireabase"; // import your Firestore instance
import { Link } from "react-router-dom";
import Avatar from "../components/Avatar";
import { useNavigate } from "react-router-dom";
import MarqueeCom from "../components/MarqueeCom";
const AllUsersComponent = ({ allUsers }) => {
  const navigate = useNavigate();
  const [users, setUsers] = useState(allUsers);
  console.log(users);

  // Fisher-Yates (aka Knuth) Shuffle algorithm
  function shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  // Shuffle users
  const shuffledUsers = shuffle(users);

  return (
    <div className="flex flex-wrap justify-center gap-10">
      {shuffledUsers &&
        shuffledUsers.map((user) => (
          <div
            key={user.id}
            style={{
              cursor: "pointer",
              boxShadow: "0px 0px 10px rgba(128,128,128,0.75)",
              borderRadius: "10px",
              width: "100px",
              height: "100px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
              color: "var(--primary-color)",
            }}
            onClick={() => navigate(`/myprofile/${user.id}`)}
          >
            {user.photoURL ? (
              <img
                src={user.photoURL}
                alt="user"
                width="100%"
                height="100%"
                style={{
                  filter: "drop-shadow(0px 0px 10px rgba(128,128,128,0.75))",
                  borderRadius: "10px",
                }}
              />
            ) : (
              <Avatar Name={user.email} />
            )}
          </div>
        ))}
    </div>
  );
};
const AllusersSearch = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const usersCollection = await getDocs(collection(db, "users"));
      setUsers(
        usersCollection.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      );
    };

    fetchUsers();
  }, []);

  console.log(users, "users");
  return (
    <React.Fragment>
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          paddingTop: "50px",
        }}
      >
        <h1 className="text-md sm:text-md md:text-xl lg:text-2xl xl:text-3xl font-bold text-center text-white my-5">
          {users && users.length} مستخدم
        </h1>
        {users.length > 0 ? (
          <AllUsersComponent allUsers={users} />
        ) : (
          <p className="text-md sm:text-md md:text-xl lg:text-2xl xl:text-3xl font-bold text-center text-white my-5">
            لا يوجد مستخدمين
          </p>
        )}
      </div>
    </React.Fragment>
  );
};

export default AllusersSearch;
